/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./psd-item.vue?vue&type=template&id=21724358&scoped=true&"
import script from "./psd-item.vue?vue&type=script&lang=js&"
export * from "./psd-item.vue?vue&type=script&lang=js&"
import style0 from "./psd-item.vue?vue&type=style&index=0&id=21724358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21724358",
  null
  
)

export default component.exports